// API Configuration
// Use relative URLs in production so it automatically uses the same domain
export const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
export const API_ENDPOINTS = {
  CONTACT: `${API_BASE_URL}/api/contact/`,
  // Add other API endpoints here as needed
};
